import React, { useState } from "react";
import {
    Typography,
    Button,
    Divider,
    Box,
    Grid,
} from "@mui/material";

const CheckMarksheetReceipt = ({ receiptData }) => {
    const [showPrintButton, setShowPrintButton] = useState(true);

    const handlePrint = () => {
        setShowPrintButton(false);
        setTimeout(() => {
            window.print();
            setShowPrintButton(true);
        }, 100);
    };

    const toCamelCase = (str) => {
        return str
            ?.toLowerCase()
            .replace(/[^a-zA-Z0-9 ]/g, '')
            .split(' ')
            .map((word, index) =>
                index === 0
                    ? word.charAt(0).toUpperCase() + word.slice(1)
                    : word.charAt(0).toUpperCase() + word.slice(1)
            )
            .join(' ');
    };

    return (
        <>
            {receiptData?.map((ms) => (
                <Box
                    key={ms.id}
                    sx={{
                        maxWidth: "800px",
                        margin: "auto",
                        p: 2,
                        border: "6px solid rgb(52, 51, 51)",
                        backgroundColor: "#fff",
                        backgroundBlendMode: "lighten",
                        backgroundSize: "150px auto",
                        opacity: 0.9
                    }}
                >
                    <Box
                        key={ms.id}
                        sx={{
                            maxWidth: "800px",
                            margin: "auto",
                            px: 4,
                            pb: 4,
                            border: "2px solid rgb(52, 51, 51)",
                            borderRadius: "10px",
                            backgroundColor: "#fff",
                            backgroundImage: `url(${ms.logo || ''})`,
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                            backgroundBlendMode: "lighten",
                            backgroundSize: "150px auto",
                            opacity: 0.9
                        }}
                    >
                        {/* Header with Logo */}
                        <Box display="flex" alignItems="center" justifyContent="flex-start" flexDirection={'column'}>
                            <img
                                src={ms.logo || ''}
                                alt="School Logo"
                                style={{ width: 80, height: 70, marginTop: 10 }}
                            />
                            <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                                {ms.schoolName || "NA"}
                            </Typography>
                            <Typography sx={{ pb: 1 }}>
                                {ms.address}
                            </Typography>
                            <Typography
                                variant="h6"
                                sx={{
                                    bgcolor: "#f0f0f0",
                                    borderRadius: 8,
                                    fontWeight: "bold",
                                    px: 2,
                                    py: 0.2,
                                    borderBottom: "3px solid #9e9d9dff",
                                    borderLeft: "2px solid #9e9d9dff",
                                    borderRight: "1px solid #9e9d9dff",
                                    mb: 2
                                }}
                            >
                                {"MARKS STATEMENT"}
                            </Typography>
                        </Box>

                        {/* Student Info Row */}
                        <Box spacing={2} display="flex" justifyContent="space-between">
                            <Typography variant="body2">
                                Roll No: <b>{ms.rollNumber}</b>
                            </Typography>
                            <Typography>
                                {toCamelCase(`${ms.examType}`)} {ms.academicYear}
                            </Typography>
                        </Box>

                        <Divider sx={{ mb: 2, mt: 1 }} />

                        {/* Student & Payment Info */}
                        <Grid container spacing={2} display="flex" justifyContent="space-between">
                            <Typography>
                                <b>Student Name:</b> {toCamelCase(`${ms.fullName}`)}
                            </Typography>
                            <Typography>
                                <b>Standard:</b> {ms.standard} | {ms.section}
                            </Typography>
                        </Grid>

                        <Grid container spacing={2} display="flex" justifyContent="space-between">
                            <Typography>
                                <b>Father's Name:</b> {toCamelCase(ms.fatherName)}
                            </Typography>
                            <Typography>
                                <b>Mother's Name:</b> {toCamelCase(ms.motherName)}
                            </Typography>
                        </Grid>

                        <Grid container spacing={2} display="flex" justifyContent="space-between">
                            <Typography>
                                <b>Date of Birth:</b> {ms.dob}
                            </Typography>
                            <Typography>
                                <b>Class Teacher:</b> {toCamelCase(ms.classTeacher)}
                            </Typography>
                        </Grid>

                        <Divider sx={{ mb: 2, mt: 1 }} />

                        {/* Marks Table */}
                        <table style={{ width: "100%", borderCollapse: "collapse" }}>
                            <thead>
                                <tr style={{ background: "#f0f0f079" }}>
                                    <th style={{ border: "1px solid #000", padding: "8px" }}>#</th>
                                    <th style={{ border: "1px solid #000", padding: "8px" }}>Subject</th>
                                    <th style={{ border: "1px solid #000", padding: "8px" }}>Marks Obtained</th>
                                    <th style={{ border: "1px solid #000", padding: "8px" }}>Max Marks</th>
                                    <th style={{ border: "1px solid #000", padding: "8px" }}>Grade</th>
                                </tr>
                            </thead>
                            <tbody>
                                {ms?.marksEntry?.map((m, index) => (
                                    <tr key={index}>
                                        <td style={{ border: "1px solid #000", padding: "8px", textAlign: "center" }}>
                                            {index + 1}
                                        </td>
                                        <td style={{ border: "1px solid #000", padding: "8px" }}>
                                            {toCamelCase(m.subjectName || m.subject)}
                                        </td>
                                        <td style={{ border: "1px solid #000", padding: "8px", textAlign: "right" }}>
                                            {m.marksObtained || m.marks}
                                        </td>
                                        <td style={{ border: "1px solid #000", padding: "8px", textAlign: "right" }}>
                                            {m.maxMark || m.maxMarks}
                                        </td>
                                        <td style={{ border: "1px solid #000", padding: "8px", textAlign: "right" }}>
                                            {m.grade}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                            <tfoot>
                                <tr style={{ background: "#f0f0f079" }}>
                                    <td colSpan="2" style={{ border: "1px solid #000", padding: "8px", textAlign: "right" }}>
                                        <b>Result: </b> {ms.result || "Fail"}
                                    </td>
                                    <td colSpan="1" style={{ border: "1px solid #000", padding: "8px", textAlign: "right" }}>
                                        <b>{ms.marksEntry?.reduce((sum, m) => sum + Number(m.maxMark || m.maxMarks || 0), 0)}</b>
                                    </td>
                                    <td style={{ border: "1px solid #000", padding: "8px", textAlign: "right" }}>
                                        <b>{ms.totalMarks}</b>
                                    </td>
                                    <td style={{ border: "1px solid #000", padding: "8px", textAlign: "right" }}>
                                        <b>{ms.grade}</b>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>

                        {/* Summary */}
                        <Box variant="body1" sx={{ my: 2 }} display="flex" justifyContent="space-between">
                            <Typography variant="body2">
                                <strong>Total Marks:</strong> {ms.totalMarks}/{ms.marksEntry?.reduce((sum, m) => sum + Number(m.maxMark || m.maxMarks || 0), 0)}
                            </Typography>
                            <Typography variant="body2">
                                <strong>Percentage:</strong> {ms.percentage?.toFixed(2) || "0.00"}%
                            </Typography>
                            <Typography variant="body2">
                                <strong>Grade:</strong> {ms.grade}
                            </Typography>
                        </Box>

                        <Typography variant="body1" color="textSecondary">
                            <b>Remarks: </b>{ms.remarks}
                        </Typography>

                        <Box my={8} display="flex" justifyContent="space-between">
                            <Typography variant="body2">Signature: ___________</Typography>
                            <Typography variant="body2">Teacher Sign.: ___________</Typography>
                            <Box>
                                <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                                    Principal/HeadMaster
                                </Typography>
                                <Typography variant="body2">Seal/Sign.: ___________</Typography>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            ))}

            {receiptData?.length > 0 && showPrintButton && (
                <Box textAlign="center" mt={3}>
                    <Button variant="contained" sx={{ bgcolor: "#3f2d01", borderRadius: 5 }} onClick={handlePrint}>
                        Print Marksheet
                    </Button>
                </Box>
            )}
        </>
    );
};

export default CheckMarksheetReceipt;